import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { gql, useMutation } from '@apollo/client';
import get from 'lodash/get';

// MaterialUI
import Button from '@material-ui/core/Button';
import DeleteIcon from '@material-ui/icons/DeleteOutlined';
import Tooltip from '@material-ui/core/Tooltip';

// app: components
import ConfirmDeletionDialog from 'components/ConfirmDeletionDialog';

const DELETE_CONVERTED_RECIPE = gql`
  mutation DeleteConvertedRecipe($id: String!) {
    DeleteConvertedRecipe(id: $id)
  }
`;

export default function RecipeConversionDelete(props) {
  const { id, onDeleteError, onDeleteCompleted } = props;
  const [confirmDeleteDialogOpen, setConfirmDeleteDialogOpen] = useState(false);

  const [deleteConvertedRecipe, { loading: isDeleting }] = useMutation(DELETE_CONVERTED_RECIPE, {
    onCompleted: () => {
      setConfirmDeleteDialogOpen(false);
      onDeleteCompleted();
    },
    onError: err => {
      console.error('Failed to delete comment', err);
      const errorCode = get(err, 'graphQLErrors[0].extensions.code');
      const niceErrorCode = errorCode ? ` (code: ${errorCode})` : '';
      const niceSaveError =
        get(err, 'graphQLErrors[0].message') ||
        `We can't save this right now. Please try again later${niceErrorCode}`;
      setConfirmDeleteDialogOpen(false);
      onDeleteError(niceSaveError);
    },
  });

  const handleDelete = event => {
    event.stopPropagation();
    setConfirmDeleteDialogOpen(true);
  };

  const handleCancelDelete = event => {
    event.stopPropagation();
    setConfirmDeleteDialogOpen(false);
  };

  const handleConfirmDelete = event => {
    event.stopPropagation();
    deleteConvertedRecipe({ variables: { id } });
  };

  return (
    <div>
      <Tooltip title="Delete conversion" aria-label="delete">
        <Button size="small" color="primary" onClick={handleDelete} disabled={isDeleting}>
          <DeleteIcon />
        </Button>
      </Tooltip>
      <ConfirmDeletionDialog
        title="Are you sure you want to delete this conversion?"
        body=""
        open={confirmDeleteDialogOpen}
        onClose={handleCancelDelete}
        onAgree={handleConfirmDelete}
      />
    </div>
  );
}
RecipeConversionDelete.propTypes = {
  id: PropTypes.string.isRequired,
  onDeleteError: PropTypes.func,
  onDeleteCompleted: PropTypes.func,
};

RecipeConversionDelete.defaultProps = {
  onDeleteError: () => {},
  onDeleteCompleted: () => {},
};
